// Create an enum for the document types
export enum CaroDocumentType {
  eftelingshowreport = 'EFTELINGSHOWREPORT',
  callsheet = 'CALLSHEET',
  protocol = 'PROTOCOL'
}

export class CARODocument {
  id?: number;
  base64?: string;
  status?: string;
  documentType?: CaroDocumentType;
  documentName?: string;
}

